// extracted by mini-css-extract-plugin
export default {"content":"summary_content__0NKH4","stats":"summary_stats__P4qKQ","title":"summary_title__VkNzm"};